import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { STORAGE_PREFIX } from '../../config/env';

interface EstadoLateral {
  plegada: boolean;
  alternar: () => void;
}

/**
 * Si la barra lateral está plegada.
 *
 * Se recuerda entre visitas porque es una preferencia del sitio de trabajo:
 * quien mira el monitoreo en una pantalla estrecha la quiere plegada siempre, y
 * volver a plegarla en cada entrada sería un peaje diario.
 *
 * Vive en su propio almacén y no en el del tema para que plegar la barra no
 * arrastre nada más: son dos preferencias sin relación.
 */
export const useLateralStore = create<EstadoLateral>()(
  persist(
    (set, get) => ({
      plegada: false,
      alternar: () => set({ plegada: !get().plegada }),
    }),
    { name: `${STORAGE_PREFIX}lateral` },
  ),
);
